import types from './types';

const getInitialData = (isCreationMode, isCloneMode) => ({
  type: types.GET_INVENTORY_INITIAL_DATA,
  params: { isCreationMode, isCloneMode }
});

const getInventory = (id, isCloneMode) => ({
  type: types.GET_INVENTORY,
  params: { id, isCloneMode }
});

const getDeletedInventory = id => ({
  type: types.GET_DELETED_INVENTORY,
  params: { id }
});

const getInventoryTitleDetails = id => ({
  type: types.GET_INVENTORY_TITLE_DETAILS,
  params: { id }
});

const saveInventory = (saveDto, mode) => ({
  type: types.SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL,
  params: { saveDto, mode }
});

const deleteInventory = (id, redirect) => ({
  type: types.DELETE_INVENTORY,
  params: { id, redirect }
});

const isPreciseLocationSet = id => ({
  type: types.IS_PRECISE_LOCATION_SET,
  params: { id }
});

const getNonCheckedChemicals = (personId, department, building) => ({
  type: types.GET_NON_CHECKED_CHEMICALS,
  params: { personId, department, building }
});

const markAsChecked = (inventoryIds) => ({
  type: types.MARK_AS_CHECKED,
  params: { inventoryIds }
});

const createInventoriesQRStickersPdf = (
  gridParameters,
  selectedInventories,
  labelsSupplier,
  labelsSupplierResultMapper,
  urlTemplateFunction,
  downloadFileName,
  errorHandler,
) => ({
  type: types.CREATE_INVENTORIES_QR_STICKERS_PDF,
  params: {
    gridParameters,
    selectedInventories,
    labelsSupplier,
    labelsSupplierResultMapper,
    urlTemplateFunction,
    downloadFileName,
    errorHandler,
  }
});

const createInventoriesQRStickersPdfSuccess = () => ({
  type: types.CREATE_INVENTORIES_QR_STICKERS_PDF_SUCCESS,
});

const createInventoriesQRStickersPdfFailure = (error) => ({
  type: types.CREATE_INVENTORIES_QR_STICKERS_PDF_FAILURE,
  params : {
    error
  }
});

export default {
  getInitialData,
  getInventory,
  getDeletedInventory,
  getInventoryTitleDetails,
  saveInventory,
  deleteInventory,
  isPreciseLocationSet,
  getNonCheckedChemicals,
  markAsChecked,
  createInventoriesQRStickersPdf,
  createInventoriesQRStickersPdfSuccess,
  createInventoriesQRStickersPdfFailure,
};
